module.exports = __webpack_public_path__ + "img/trading_log.570fcb35.png";